import AuthorizationsService from "../../services/authorizations/AuthorizationsService"
import ProviderService from '../../services/masters/ProviderService'
import dayjs from 'dayjs'
const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')


import { mapActions, mapState, mapGetters } from 'vuex'

export default {
    data() {
        const today = new Date()
        return {
            rangeBefore:1,
                rangeAfter: 1,
            a:0,
            m:0,
            perPage: 5,
            current: 1,
            tresprimeros:[],
            minDate: new Date(today.getFullYear(), today.getMonth() - 182),
            maxDate: new Date(today.getFullYear(), today.getMonth() + 182),
            page:0,
            total_records:0,
            rowsPerPage:5,
            currentPage: 0,
            medicinesData: [],
            checkedRows: [],
            orderDetails: [],
            slidingScaleFee: 0,
            shippingFee: 0,
            providers: [],
            patient: null,
            name: '',
            importations: [],
            idPatient: null,
            date: '',
            resultadostabla:[],
            resultadoparcial:[],
            data: [],
            medcicina:[],
            fecha: [],
            searchString: '',
            isFullPage: true,
            datesFilter: [],
            monthNames: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            dayNames: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
            showNoFilterResults: false,
            isLoading: true,
            initialDate: null,
            finalDate: null,
            resultadoK:[],
            medicinas:[],
            resultadoparcial:[],
            resultadooriginal:[],
            cargainicial:[],
            ancho:"",
            tipo: "",
        }
    },

    async created() {
   this.ancho=window.innerWidth;
  
        console.log('este es anchoooo',this.ancho);

       
        this.tipo = (this.ancho < 769 )?"celular":"pc";


        await this.getAppOrderPatient(this.tipo)
        this.isLoading = false
        dayjs.extend(isSameOrBefore)
        dayjs.extend(isSameOrAfter)
      
              
    },

    computed: {
      

        ...mapState('auth', [
            'user',
            'identification'
        ]),

        ...mapGetters('auth', {
            isAuthenticated: 'isAuthenticated',
        })

    },

    methods: {
        
        routerOrder() {
            this.$router.push("/home");
        },
        clearDatePicker() {
            this.$router.go("/order");
            this.searchString= null
            this.datesFilter = []
            this.initialDate = null
            this.finalDate = null
            this.getAppOrderPatient();
        },

        async clearHistory() {
            this.datesFilter = []
            this.searchString = ''
            this.initialDate = null
            this.finalDate = null
            this.filterHistory()
        },

        next (page) {
           console.log("page ===>",page);
          },

        async filterHistory() {
            // this.searchString = this.searchString.toLowerCase()
            if (this.initialDate !== null || this.finalDate !== null) {
                if (this.initialDate !== null && this.finalDate !== null) {
                    let initialDate = dayjs(this.initialDate)
                    let finalDate = dayjs(this.finalDate)
                    if (finalDate >= initialDate) {
                        if (this.searchString.length > 0) {
                            for (let index = 0; index < this.data.length; index++) {
                                const order = this.data[index];
                                this.data[index].show = false
                                let generationDate = dayjs(order.generationDate)
                                let dateBetween = generationDate.isSameOrAfter(initialDate) && generationDate.isSameOrBefore(finalDate)
                                if (dateBetween) {
                                    if (order.id.toString().includes(this.searchString)) {
                                        this.data[index].show = true
                                        continue
                                    }
                                    for (let i = 0; i < order.authorizations.length; i++) {
                                        if (order.authorizations[i].toLowerCase().includes(this.searchString)) {
                                            this.data[index].show = true
                                            break
                                        }
                                    }
                                    if (!this.data[index].show) {
                                        for (let i = 0; i < order.medicines.length; i++) {
                                            if (order.medicines[i].toLowerCase().includes(this.searchString)) {
                                                this.data[index].show = true
                                                break
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            for (let index = 0; index < this.data.length; index++) {
                                const order = this.data[index];
                                this.data[index].show = false
                                let generationDate = dayjs(order.generationDate)
                                let dateBetween = generationDate.isSameOrAfter(initialDate) && generationDate.isSameOrBefore(finalDate)
                                if (dateBetween) {
                                    this.data[index].show = true
                                }
                            }
                        }
                    } else {
                        this.$buefy.toast.open({ message: 'La fecha final debe ser mayor a la inicial', type: 'is-danger' })
                    }
                } else {
                    this.$buefy.toast.open({ message: 'Si deseas usar el filtro por fecha debes seleccionar una fecha inicial y una final', type: 'is-danger' })
                }
            } else if (this.searchString.length > 0) {
                for (let index = 0; index < this.data.length; index++) {
                    const order = this.data[index];
                    this.data[index].show = false
                    if (order.id.toString().includes(this.searchString)) {
                        this.data[index].show = true
                        continue
                    }
                    for (let i = 0; i < order.authorizations.length; i++) {
                        if (order.authorizations[i].toLowerCase().includes(this.searchString)) {
                            this.data[index].show = true
                            break
                        }
                    }
                    if (!this.data[index].show) {
                        for (let i = 0; i < order.medicines.length; i++) {
                            if (order.medicines[i].toLowerCase().includes(this.searchString)) {
                                this.data[index].show = true
                                break
                            }
                        }
                    }
                }
            } else {
                this.data.forEach((order, index) => {
                    this.data[index].show = true
                })
            }

            let anyFiltered = this.data.filter(order => {
                return order.show === true
            })
            this.showNoFilterResults = anyFiltered.length > 0 ? false : true
            this.$forceUpdate()
        },
       
         
          async ver(dataItem,index){

            this.tipo = 'pc'; 
             var id = dataItem.id;
             dataItem.alldata = !dataItem.alldata;
            console.log("datos de entrada ==>",id+"*****",index);
            console.log("resultado array ==>",this.resultadoparcial[index].orderDetailMedicines.length);

            if(dataItem.alldata){
                console.log("paso 1",dataItem.orderDetailsall);
                dataItem.orderDetails = dataItem.orderDetailsall;
                var order = dataItem ;
                order.orderDetailMedicines= dataItem.orderDetailsalldd;
            }else{
                console.log("paso 2",dataItem.orderDetailsoriginal);
                dataItem.orderDetails = dataItem.orderDetailsoriginal;
                var order = dataItem ;
                order.orderDetailMedicines= dataItem.orderDetailsoriginaldd;
            }
            
            
           
        },
        async verDetalle(dataItem,index){
          
            this.tipo = 'celular';
           
            var id = dataItem.id;
            dataItem.alldata = !dataItem.alldata;
           console.log("datos de entrada ==>",id+"*****",index);
           console.log("resultado array ==>",this.resultadoparcial[index].orderDetailMedicines.length);

           if(dataItem.alldata){
            console.log("paso 1",dataItem.orderDetailsall);
            dataItem.orderDetails = dataItem.orderDetailsall;
            var order = dataItem ;
            order.orderDetailMedicines= dataItem.orderDetailsalldd;
        }else{
            console.log("paso 2",dataItem.orderDetailsoriginal);
            dataItem.orderDetails = [];
            var order = dataItem ;
            order.orderDetailMedicines= [];
        }
           
           
          
       },
      
        onPageChange(val){
            
            this.current = val;

            console.log('manager.vue onPageChange event', this.current);
     
            
            //  this.data.slice(page_number * this.perPage, (page_number + 1) * this.perPage);
            this.getAppOrderPatient();
        },

        async getAppOrderPatient() {  
            this.isLoading = false;
           
            // this.resultadoparcial = [];
            if(this.current  == 0){
var enviar = 0;
            }
else{
    var enviar = this.current -1;
}
            const data = {
                page:enviar ,
                rowsPerPage: this.rowsPerPage,
                initialDate: this.initialDate,
                finalDate: this.finalDate,
                identification: this.identification,
                orderId:this.searchString
              };
            const response = await AuthorizationsService.getAppOrderPatient(data)
            
            this.data = response.data.reponse;
           this.cargainicial = this.data;

           console.log("carga inicial ===>", this.cargainicial);
           /* if(this.ancho <= 768){
            this.resultadoparcial=this.data.map(x=>{
                x.cantidad = x.orderDetails.length;
                x.orderDetails= x.orderDetails.slice(0,2);
                x.orderDetailMedicines= x.orderDetails[0].orderDetailMedicines.slice(0,2);
                x.cantidaddes = x.orderDetails[0].orderDetailMedicines.length;
                x.orderDetailsallmovil= x.orderDetails[0].orderDetailMedicines;
                
                x.show=true;
                 return x
            })
         }else{ */
         
            this.resultadoparcial=this.data.map(x=>{

                x.cantidad = x.orderDetails.length;
                x.cantidaddes = x.orderDetails[0].orderDetailMedicines.length;

                if(this.tipo == "celular"){
                    this.rangeBefore=0;
                    this.rangeAfter=0;
                    var orderDetailMedicines = [];
                    var orderDetails = [];
                    var xx = [];
                    var orderDetailsoriginaldd = []; 
                    x.orderDetailsallmovil= [];
                    x.orderDetailsalldd= [];
                }else if( this.tipo = 'pc'){

                    var orderDetailMedicines = x.orderDetails[0].orderDetailMedicines.slice(0,2)
                    var orderDetails  = x.orderDetails.slice(0,2);
                    var xx = x.orderDetails.slice(0,2);
                    var orderDetailsoriginaldd = x.orderDetails[0].orderDetailMedicines.slice(0,2);
                    x.orderDetailsalldd= x.orderDetails[0].orderDetailMedicines; 
                    x.orderDetailsallmovil= x.orderDetails[0].orderDetailMedicines;
                }

               
                x.orderDetailsoriginal = orderDetails
                x.orderDetailsall= x.orderDetails;
                x.orderDetails= orderDetails;
                
                x.orderDetailsoriginaldd = orderDetailsoriginaldd
                x.orderDetailMedicines= orderDetailMedicines;
                
               
                x.show=true;
                x.alldata = 0;
                 return x
                  
             })
        //  }
            
             
        

             console.log("resultado parcial===>",this.resultadoparcial);

            this.resultadostabla = response.data;
            this.resultadooriginal = this.resultadoparcial; 
            this.total_records= response.data.total_records;
         
          
           console.log("total ===>",this.total_records);

            this.data = this.data.sort((a, b) => new Date(b.generationDate).getTime() - new Date(a.generationDate).getTime())

            this.data.forEach(orderItem => {
                orderItem.show = true
                let generationDateFormatter = new Date(orderItem.generationDate)
                orderItem.generationDate = dayjs(generationDateFormatter).format('YYYY-MM-DD')
                orderItem.tooltip = ''
                switch (orderItem.status) {
                    case 'CANCELED':
                        orderItem.status = 'Cancelado'
                        orderItem.statusFixed = 'Cancelado'
                        orderItem.tooltip = 'Tu pedido no puede ser entregado. Tu pedido ha sido cancelado '
                        break;
                    case 'CHECKED_OUT':
                        orderItem.status = 'Distribución'
                        orderItem.statusFixed = 'Distribución'
                        orderItem.tooltip = 'Tu pedido se ha enviado para ser entregado en el domicilio.'
                        break;
                    case 'DELIVERED':
                        orderItem.status = 'Entregado'
                        orderItem.statusFixed = 'Entregado'
                        orderItem.tooltip = 'Tu pedido ha sido entregado'
                        break;
                    case 'SCHEDULED':
                        orderItem.status = 'Agendado'
                        orderItem.statusFixed = 'Agendado'
                        orderItem.tooltip = 'Tu pedido ha sido registrado con éxito'
                        break;
                    case 'PARTIALLY_CHECKED_IN':
                        orderItem.status = 'Empacado'
                        orderItem.statusFixed = 'Empacado'
                        orderItem.tooltip = 'Tu pedido está siendo preparado para realizar el envío.'
                        break;
                    case 'CHECKED_IN':
                        orderItem.status = 'Empacado'
                        orderItem.statusFixed = 'Empacado'
                        orderItem.tooltip = 'Tu pedido está siendo preparado para realizar el envío.'
                        break;
                    case 'CLOSURE_IN_PROGRESS':
                        orderItem.status = 'Entregado'
                        orderItem.statusFixed = 'Entregado'
                        orderItem.tooltip = 'Tu pedido ha sido entregado'
                        break;
                    case 'RETURNED':
                        orderItem.status = 'Devuelto'
                        orderItem.statusFixed = 'Devuelto'
                        orderItem.tooltip = 'Tu pedido no pudo ser entregado. Tu pedido ha sido devuelto'
                        break;
                    default:
                        break;
                }
                let realDateText = ''
                if (orderItem.realDate) {
                    let dateToShow = new Date(orderItem.realDate)
                    realDateText = ` el ${dayjs(dateToShow).format('YYYY-MM-DD')}`
                }
                orderItem.status = orderItem.status + realDateText
                // let dataTable = []
                let authorizations = []
                let medicines = []
                orderItem.orderDetails.forEach(od => {
                    authorizations.push(od.code)
                    // let dataMedicines = []
                    od.orderDetailMedicines.forEach(odm => {
                        odm.showQuantity = (orderItem.status === 'Empacado' || orderItem.status === 'Distribución' || orderItem.status === 'Entregado') ? odm.deliveredQuantity : odm.quantity
                        medicines.push(odm.description)
                        // dataMedicines.push({
                        //     authorization: '',
                        //     description: odm.description,
                        //     showQuantity: (orderItem.status === 'Empacado' || orderItem.status === 'Distribución' || orderItem.status === 'Entregado') ? odm.deliveredQuantity : odm.quantity,
                        //     pending: odm.quantity - odm.deliveredQuantity,
                        //     id: ''
                        // })
                    })
                    // dataTable.push({
                    //     authorization: od.code,
                    //     description: '',
                    //     pending: 0,
                    //     items: dataMedicines,
                    //     id: orderItem.id,
                    //     showQuantity: '' 
                    // })
                })
                // orderItem.dataTable = dataTable
                orderItem.authorizations = authorizations
                orderItem.medicines = medicines

            })
               
               

            //    console.log("lllllllllll",this.resultadoparcial)    
        },
        showOrderDetailQuantity(status) {
            let result = false
            if (status != 'Agendado' && status != 'Cancelado') {
                result = true
            }
            return result
        },
        showOrderDetailDeliveredQuantity(status) {
            let result = false
            if (status == 'Empacado' || status == 'Distribución') {
                result = true
            }
            return result
        }
    }
}